import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBox, FiCode, FiSettings, FiLogOut, FiCloudLightning, FiMenu, FiX } = FiIcons;

const Header = ({ currentView, onViewChange, onLogout, connectionInfo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menu = [
    { id: 'dashboard', label: 'Workspace', icon: FiBox },
    { id: 'api', label: 'API Hub', icon: FiCode },
    { id: 'config', label: 'Ajustes', icon: FiSettings },
  ];

  const handleNav = (id) => {
    onViewChange(id);
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white border-b border-slate-100 sticky top-0 z-[60] px-4 sm:px-6">
      <div className="max-w-7xl mx-auto h-16 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="bg-indigo-600 p-2 rounded-xl shadow-lg shadow-indigo-100">
            <SafeIcon icon={FiCloudLightning} className="text-white text-lg" />
          </div>
          <div className="hidden xs:block">
            <h1 className="text-sm font-black text-slate-900 leading-none tracking-tight">GretaBase</h1>
            <span className="text-[9px] text-indigo-500 font-black uppercase tracking-tighter">Mobile OS</span>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-1">
          {menu.map(item => (
            <button key={item.id} onClick={() => handleNav(item.id)} className={`flex items-center space-x-2 px-4 py-2 rounded-xl text-xs font-black uppercase tracking-widest transition-all ${currentView === item.id ? 'bg-indigo-50 text-indigo-700' : 'text-slate-400 hover:bg-slate-50'}`}>
              <SafeIcon icon={item.icon} />
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="flex items-center space-x-4">
          <div className="hidden sm:block text-right border-l pl-4">
            <p className="text-[10px] font-black text-slate-900 uppercase truncate max-w-[120px]">{connectionInfo.currentUser?.email.split('@')[0]}</p>
            <p className="text-[9px] text-emerald-500 font-bold uppercase tracking-widest">● Online</p>
          </div>
          
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden p-2 text-slate-400">
            <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-xl" />
          </button>
          
          <button onClick={onLogout} className="hidden sm:block p-2 text-slate-300 hover:text-red-500 transition-colors">
            <SafeIcon icon={FiLogOut} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-slate-100 p-4 space-y-2 shadow-xl animate-in fade-in slide-in-from-top-4">
          {menu.map(item => (
            <button key={item.id} onClick={() => handleNav(item.id)} className={`w-full flex items-center space-x-4 p-4 rounded-2xl text-xs font-black uppercase tracking-widest ${currentView === item.id ? 'bg-indigo-600 text-white' : 'bg-slate-50 text-slate-400'}`}>
              <SafeIcon icon={item.icon} />
              <span>{item.label}</span>
            </button>
          ))}
          <button onClick={onLogout} className="w-full flex items-center space-x-4 p-4 rounded-2xl text-xs font-black uppercase tracking-widest bg-red-50 text-red-500">
            <SafeIcon icon={FiLogOut} />
            <span>Encerrar Sessão</span>
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;